export default __webpack_public_path__ + "static/media/korok-yahaha.9a1f386c.mp3";